import { isAlertInProgress } from "src/services/alert";
import { ShortAlert } from "src/types/alert";

export const getOpenAlert = (alerts: ShortAlert[]) => {
  return alerts.find(isAlertInProgress);
};
